export const PUBLISH_LIST_FAILED = "PUBLISH_LIST_FAILED";
export const PUBLISH_LIST_SUCCESS = "PUBLISH_LIST_SUCCESS";
export const PUBLISH_LIST_ATTEMPT = "PUBLISH_LIST_ATTEMPT";
////////////////////////////////////////
export const PUBLISH_NEW_SUCCESS = "PUBLISH_NEW_SUCCESS";
export const PUBLISH_NEW_FAILED = "PUBLISH_NEW_FAILED";
export const LOGOUT = "LOGOUT";